<template>
  <div class="room-list-card active" :style="roomCustomStyles" @click="joinRoom">
    <div class="room-list-card--body">
      <span v-if="room.ROOM_LOGO && room.ROOM_IMAGE === 'logo'" class="room-list-card__logo">
        <img :src="room.ROOM_LOGO" aria-hidden="true" />
      </span>
      <div class="room-list-card--content">
        <i v-if="room.ROOM_ICON && room.ROOM_IMAGE === 'icon'" :class="room.ROOM_ICON" aria-hidden="true"></i>
        <div>
          <h5 class="body-title">{{ room.TITLE }}</h5>
          <p v-if="room.DESCRIPTION" v-html="room.DESCRIPTION" class="body-description"></p>
        </div>
      </div>
    </div>
    <div class="room-list-card--footer">
      <div>
        <i class="fa fa-users" aria-hidden="true"></i>
        <small>{{ getRoomUsersLength }}</small>
      </div>
      <span style="padding: 2px">
        <template v-if="!isCurrent">
          <i class="fa fa-sign-in" aria-hidden="true" style="margin-right: 2px"></i>
          Enter room
        </template>
        <template v-else>
          <b>Current room</b>
        </template>
      </span>
    </div>
  </div>
</template>

<script>
import { ROUTES } from "@/helpers/constants";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "RoomListCard",
  props: {
    room: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState("room", ["activeRoom"]),
    ...mapGetters({
      multipleRooms: "room/multipleRooms",
      users: "room/roomState"
    }),
    /** Hide join button for current room */
    isCurrent() {
      return this.activeRoom === this.room.SLUG;
    },
    roomCustomStyles() {
      if (this.room.ROOM_COLOUR_TYPE === "custom" && this.room.ROOM_COLOUR) {
        return {
          "--room-color": this.room.ROOM_COLOUR,
          order: this.order || 0,
          border: this.isCurrent ? "" : "none"
        };
      }
      return { "--room-color": "var(--color-primary)", order: this.order || 0, border: this.isCurrent ? "" : "none" };
    },
    order() {
      return this.multipleRooms.find(room => room.uuid === this.room.uuid)?.room_order;
    },
    getRoomUsersLength() {
      return this.users.filter(user => user.roomUUID === this.room.uuid).length;
    }
  },
  methods: {
    ...mapActions({
      changeRoom: "room/changeRoom"
    }),
    async joinRoom() {
      if (this.isCurrent) return;
      this.$router.push({ name: ROUTES.DIGITAL_EVENT_ROOM, params: { roomSlug: this.room.SLUG } });
      await this.changeRoom({ slug: this.room.SLUG, enterRoomUUID: this.room.uuid });
    }
  }
};
</script>

<style lang="less">
@import "../../../../../theme.less";

.room-list-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 350px;
  min-height: 80px;
  border: 1px solid var(--room-color);
  background-color: var(--section-bg-color);
  cursor: pointer;

  &__logo {
    margin: 5px;
    width: 50px;
    height: 50px;
    background-color: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-height: 100%;
    }
  }
  &--body {
    display: flex;
  }
  &--content {
    display: flex;
    padding: 15px;
    padding-bottom: 0;
    color: var(--room-color);

    i {
      font-size: 24px;
      margin-right: 10px;
    }

    h5 {
      margin-top: 0;
      margin-bottom: 5px;
      font-weight: bold;

      small {
        color: inherit;
      }
    }

    p {
      font-weight: bold;
      font-size: 12px;
      color: @gray-light;
    }
  }

  &--footer {
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
    padding: 5px;
    background-color: var(--room-color, --color-primary);
    color: #fff;

    button {
      background-color: inherit;
      border: none;
    }

    & > div {
      background-color: rgba(255, 255, 255, 0.3);
      padding: 2px 8px;
    }

    i {
      margin-right: 5px;
    }
  }
}
</style>
